<template>
    <div>
        <van-search v-model="value" show-action placeholder="请输入搜索关键词">
            <template #action>
                <div @click="onSearch">搜索</div>
            </template>
        </van-search>
        <baidu-map :center="center" :zoom="zoom" :scroll-wheel-zoom="true" class="bm-view" :ak="ak" @ready="handler" :style="{height: mapHeight}">
            <bm-local-search :keyword="keyword" :autoViewport="true" :panel="false" :page-capacity="30"
                             @markersset="getAllPoint" />
        </baidu-map>
        <van-popup v-if="searchData.length>0" v-model="showPop" :style="{ height: popHeight }" position="bottom" @close="setMapHeight">
            <div style="position: fixed;width: 100%;background: white">
                <div style="text-align: center;"><a><span class="iconfont icon-jianhao" @click="triggerPopHeight"></span></a></div>
                <div class="content" style="padding-left: 1rem;font-size: 0.9rem" >
                    {{keyword}}<span>·</span>找到{{searchData.length}}个结果
                </div>
            </div>
            <div style="padding-top: 2.5rem">
                <van-list finished-text="没有更多了">
                    <div v-for="item in searchData" class="companyCard" :key="item.uid" @click="selectNode(item)">
                        <div style="display: inline-block">
                            <div class="header">
                                <span class="title">{{item.title}}</span>
                            </div>
                            <p class="content">{{item.address || '无'}}</p>
                        </div>
                       <div style="float: right;top: 17px;position: relative;">
                           <van-icon size="25" color="inherit" name="plus" @click="getCompany(item,$event)" />
                       </div>
                    </div>
                </van-list>
            </div>
        </van-popup>
        <van-popup round v-model="showDetailPop"
                   style="height: 80%"
                   position="bottom"
                   closeable
                   close-icon="close">
            <div style="padding-top: 1rem">
                <div style="padding: 0.5rem 1rem 0 1rem">
                    <table>
                        <tr>
                            <td style="width: 80%">
                                <div >
                                <span>{{data.title}}</span>
                                <p style="color: #969799;">{{data.address}}</p>
                            </div>
                            </td>
                            <td width="70">
                                <div style="line-height: 70px;background: #eaeaea;text-align: center;">
                                    <span style="color: #969696;">无</span>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div style="padding: 0.5rem">
                    <van-button style="width: 100%" type="default" color="#969798" @click="saveCustomer">导入到我的客户</van-button>
                </div>
                <div>
                    <van-cell-group>
                        <van-cell size="large" title="客户名称" :value="companyInfo.name" readonly/>
                        <van-cell size="large" title="联系人" :value="companyInfo.legalPersonName" readonly/>
                        <van-cell size="large" title="成立时间" :value="companyInfo.regTime" readonly/>
                        <van-cell size="large" title="纳税人识别号" :value="companyInfo.creditCode" readonly/>
                    </van-cell-group>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
    import {Search, Button, Toast, Popup, List, CellGroup, Cell, Icon } from 'vant';
    import BaiduMap from 'vue-baidu-map/components/map/Map'
    import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch'
    import companyService from '../service/companyService'
    import customerService from '../service/customerService'
    export default {
        data () {
            return {
                ak:"MmRMkYkpPgpcznx0KwFz5EX633IsHXOU",
                center: {lng: 0, lat: 0},
                zoom: 13,
                popHeight: "30%",
                value: '超市',
                keyword: '超市',
                mapHeight: '600px',
                isDraw:false,
                showPop: false,
                showDetailPop: false,
                searchData:[],
                companyInfo:{},
                data:{}
            }
        },
        components: {
            BaiduMap,
            BmLocalSearch,
            [Cell.name]: Cell,
            [Icon.name]: Icon,
            [List.name]: List,
            [Popup.name]: Popup,
            [Search.name]: Search,
            [Button.name]: Button,
            [CellGroup.name]: CellGroup,
        },
        methods: {
            handler () {
                this.center.lng = 116.404;
                this.center.lat = 39.915;
                this.zoom = 15;
            },
            selectNode(data){
                this.data = data;
                this.center = data.point;
            },
            getCompany(data,e){
                e.stopPropagation();
                this.selectNode(data);
                this.getCompanyInfo();
            },
            getAllPoint(data){
                this.showPop = true;
                this.searchData=data;
            },
            triggerPopHeight(){
                this.isDraw = !this.isDraw;
                this.popHeight = this.isDraw ? "70%" : "30%";
                this.mapHeight = this.isDraw ? "200px" : "600px";
            },
            onSearch(){
                this.showPop = true;
                this.keyword = this.value;
                this.mapHeight = this.isDraw ? "200px" : "600px";
            },
            setMapHeight(){
                this.mapHeight = "600px";
            },
            getCompanyInfo: async function () {
                let resp = await companyService.getCompanyInfoByName(this.data.title);
                if (resp.data.Status === "1"){
                    this.companyInfo = resp.data.Data;
                    this.showDetailPop = true;
                } else {
                    Toast.fail(resp.data.Message);
                }
            },
            saveCustomer: async function () {
                const map = {};
                map.address = this.data.address;
                map.name = this.companyInfo.name;
                map.contact = this.companyInfo.legalPersonName;
                map.taxId = this.companyInfo.creditCode;
                map.startDate = this.companyInfo.regTime;
                const resp = await customerService.saveCustomer(map);
                if (resp.data.Status === "1"){
                    Toast.success(resp.data.Data);
                    this.showDetailPop = false;
                } else {
                    Toast.fail(resp.data.Message);
                }
            }
        }
    }
</script>

<style>
    .content{
        width: 20rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .van-icon-close{
        color: #929596;
        top: 0.5rem;
    }
    .companyCard{
        background-color: white;
        padding: 0.6rem;
        border-top: 1px solid #f3f3f3;
        font-size: 0.8rem;
    }
</style>